import { HorizontalSafeAreaContainer } from '../../../components';
import { HsaFsaScreen } from '../../../screens/HsaFsaScreen';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <HsaFsaScreen />
    </HorizontalSafeAreaContainer>
  );
}
